import CustomButton from '../../../common/components/CustomButton';
import CustomTextArea from '../../../common/components/CustomTextAera';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeModificationFormView2CorrectionViewFieldName = 'correction';

export default function KaraokeModificationFormView2CorrectionView({
  getValue,
  setValue,
  getErrors,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView2CorrectionViewFieldName) => string,
  setValue: (name: KaraokeModificationFormView2CorrectionViewFieldName, value: string) => void,
  getErrors: (name: KaraokeModificationFormView2CorrectionViewFieldName) => FieldValidationErrorsType,
  onNext: () => void,
}) {
  return (
    <form>
      <div className="form__body">
        <dl>
          <dt>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="">修正理由</label>
          </dt>
          <dd>
            <CustomTextArea
              value={getValue('correction')}
              setValue={(value) => setValue('correction', value)}
              validationErrors={getErrors('correction')}
            />
            <p className="text_info_on">修正内容を入力してください。</p>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="default" onClick={() => onNext()}>確認画面へ</CustomButton>
          </li>
        </ul>
        <p>
          こちらは修正依頼の窓口です。質問やその他の連絡は
          <a href="/contact">こちら</a>
          から
        </p>
      </div>
    </form>
  );
}

